import { useState, useEffect, useRef, useCallback, Fragment, useMemo, useContext } from "react";
import style from "./EventList.module.scss";
import { v4 } from "uuid";
import { BottomSheet } from "react-spring-bottom-sheet";
import * as YStyled from "../../Styleds";
import LogItem from "../../comm/global/components/LogItem";
import AlbumItem from "../../comm/global/components/AlbumItem";
import EventItem from "../../comm/global/components/EventItem";
import apiManager from '../../ApiManager';
import { GameContext } from "../../GameContext";
import MyBottomSheet from "../../comm/global/components/MyBottomSheet";
const EventList = ({ arg, addModalType, setModalType }) => {
    const { preProcessEvent,userData } = useContext(GameContext);
    const [isOpen, set_isOpen] = useState(true);
    const [events, set_events] = useState([]);
    useEffect(() => {
        console.log("arg",arg);
        if (arg.type === "friend") {
            apiManager.fetchGet(`user/${arg.user_id}/events`, {past: true}, 0).then(res => {
                const processEvents = async () => {
                    const __events = await Promise.all(res.map(async (event) => {
                        return await preProcessEvent(event);
                    }));
                    const _events=arg.events.slice(5).concat(__events).splice(0,20);
                    set_events(_events);
                };
                processEvents();
            })
        }
        else {
            apiManager.fetchGet("my/event", {past: true}, 0).then(res => {
                console.log(res);
                const processEvents = async () => {
                    const __events = await Promise.all(res.map(async (event) => {
                        return await preProcessEvent(event);
                    }));
                    const _events=arg.events.slice(5).concat(__events).splice(0,20);
                    set_events(_events);
                };
                processEvents();
            })
        }
       
        
        set_isOpen(true);
    }, [])
    useEffect(() => {
    }, [isOpen])
    return (
        <div className={style.app} id="background" onClick={async e => {
            console.log("e.target.id", e.target.id)
            if (e.target.id === "background") {
                set_isOpen(false);
                await new Promise(resolve => requestAnimationFrame(resolve));
                setModalType(prev => prev.filter(v => v.cls !== "EventList"))
            }
        }}>
            <MyBottomSheet canDrag={false} zIndex={1000} display={true}
                header={
                    <div className={style.header} id="background"></div>
                }
                content={<div className={style.content} >
                    <img src="./tab1/Whale.png" id="background" />
                    <div className={style.list} >
                        {events.map((v, k) => {
                            return <EventItem key={k} onClick={e => {
                                addModalType({
                                    cls: "EventDetail", arg: {
                                        cb: () => {
                                        },
                                        vo: v
                                    }
                                })
                            }} eventVo={v} addModalType={addModalType}></EventItem>
                        })}
                    </div>

                </div>}
            >

            </MyBottomSheet>
        </div>

    );
}

export default EventList;